import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../providers/auth.service';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {

  @ViewChild('signForm') signForm: NgForm;
  email: String;
  password: String;

  constructor(public authService: AuthService, private router: Router) {
    // console.log('signin constructor');
  }

  ngOnInit() { }

  onSubmit() {
    // console.log(this);
    this.authService.loginEmail(this.email, this.password).then(
      (user?) => {
      //   console.log('resolved: ' + JSON.stringify(user));
        this.router.navigate(['home']);
      },
      (err) => {
        console.log('rejected: ' + err.message);
        console.log(this.signForm);
        this.signForm.control.setErrors({ remote: err.message });
      }
    );
  }
  get showErrors() {
    return this.signForm.control.errors.remote;
  }

}


// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/signin/signin.component.ts